<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none">
        <path
            d="M2.23077 2.84619C1.90434 2.84619 1.5913 2.97587 1.36048 3.20667C1.12967 3.43749 1 3.75054 1 4.07696V15.7693C1 16.0957 1.12967 16.4088 1.36048 16.6395C1.5913 16.8703 1.90434 17 2.23077 17H15.7692C16.0956 17 16.4087 16.8703 16.6395 16.6395C16.8703 16.4088 17 16.0957 17 15.7693V4.07696C17 3.75054 16.8703 3.43749 16.6395 3.20667C16.4087 2.97587 16.0956 2.84619 15.7692 2.84619H13.3077"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.69141 1V4.69231"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.3086 1V4.69231"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.69141 2.84619H10.8453"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.0006 5.99902C7.66074 5.99902 7.38522 6.27454 7.38522 6.61441V8.34521H5.65445C5.31458 8.34521 5.03906 8.62073 5.03906 8.9606V10.9606C5.03906 11.3005 5.31458 11.576 5.65445 11.576H7.38522V13.3067C7.38522 13.6466 7.66074 13.9221 8.0006 13.9221H10.0006C10.3405 13.9221 10.616 13.6466 10.616 13.3067V11.576H12.3468C12.6866 11.576 12.9622 11.3005 12.9622 10.9606V8.9606C12.9622 8.62073 12.6866 8.34521 12.3468 8.34521H10.616V6.61441C10.616 6.27454 10.3405 5.99902 10.0006 5.99902H8.0006Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
